 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLCH00_FM01_HALF from '@/components/xhtml/ch00_fm01_half'
 import XHTMLCH00_FM02_TITLE from '@/components/xhtml/ch00_fm02_title'
 import XHTMLCH00_FM03_COPYRIGHT from '@/components/xhtml/ch00_fm03_copyright'
 import XHTMLCH00_FM04_DEDI from '@/components/xhtml/ch00_fm04_dedi'
 import XHTMLCH00_FM05_NOTE from '@/components/xhtml/ch00_fm05_note'
 import XHTMLCH00_FM06_FORE from '@/components/xhtml/ch00_fm06_fore'
 import XHTMLCH00_FM07_ACK from '@/components/xhtml/ch00_fm07_ack'
 import XHTMLCH00_FM08_PREFACE from '@/components/xhtml/ch00_fm08_preface'
 import XHTMLCH00_FM09_TOC from '@/components/xhtml/ch00_fm09_toc'
 import XHTMLCH00_FM10_ILLUS from '@/components/xhtml/ch00_fm10_illus'
 import XHTMLPART01 from '@/components/xhtml/part01'
 import XHTMLPART01_CH01 from '@/components/xhtml/part01_ch01'
 import XHTMLPART01_CH02 from '@/components/xhtml/part01_ch02'
 import XHTMLPART01_CH03 from '@/components/xhtml/part01_ch03'
 import XHTMLPART01_CH04 from '@/components/xhtml/part01_ch04'
 import XHTMLPART01_CH05 from '@/components/xhtml/part01_ch05'
 import XHTMLPART02 from '@/components/xhtml/part02'
 import XHTMLPART02_CH01 from '@/components/xhtml/part02_ch01'
 import XHTMLPART02_CH02 from '@/components/xhtml/part02_ch02'
 import XHTMLPART03 from '@/components/xhtml/part03'
 import XHTMLPART03_CH01 from '@/components/xhtml/part03_ch01'
 import XHTMLPART03_CH02 from '@/components/xhtml/part03_ch02'
 import XHTMLPART03_CH03 from '@/components/xhtml/part03_ch03'
 import XHTMLPART03_CH04 from '@/components/xhtml/part03_ch04'
 import XHTMLPART03_CH05 from '@/components/xhtml/part03_ch05'
 import XHTMLPART03_CH06 from '@/components/xhtml/part03_ch06'
 import XHTMLPART04 from '@/components/xhtml/part04'
 import XHTMLPART04_CH01 from '@/components/xhtml/part04_ch01'
 import XHTMLPART04_CH02 from '@/components/xhtml/part04_ch02'
 import XHTMLPART04_CH03 from '@/components/xhtml/part04_ch03'
 import XHTMLPART04_CH04 from '@/components/xhtml/part04_ch04'
 import XHTMLPART05 from '@/components/xhtml/part05'
 import XHTMLPART05_CH01 from '@/components/xhtml/part05_ch01'
 import XHTMLPART05_CH02 from '@/components/xhtml/part05_ch02'
 import XHTMLPART05_CH03 from '@/components/xhtml/part05_ch03'
 import XHTMLPART06 from '@/components/xhtml/part06'
 import XHTMLPART06_CH01 from '@/components/xhtml/part06_ch01'
 import XHTMLPART06_CH02 from '@/components/xhtml/part06_ch02'
 import XHTMLPART06_CH03 from '@/components/xhtml/part06_ch03'
 import XHTMLPART06_CH04 from '@/components/xhtml/part06_ch04'
 import XHTMLPART06_CH05 from '@/components/xhtml/part06_ch05'
 import XHTMLPART07 from '@/components/xhtml/part07'
 import XHTMLPART07_CH01 from '@/components/xhtml/part07_ch01'
 import XHTMLPART07_CH02 from '@/components/xhtml/part07_ch02'
 import XHTMLPART07_CH03 from '@/components/xhtml/part07_ch03'
 import XHTMLPART08 from '@/components/xhtml/part08'
 import XHTMLPART08_CH01 from '@/components/xhtml/part08_ch01'
 import XHTMLPART08_CH02 from '@/components/xhtml/part08_ch02'
 import XHTMLPART09 from '@/components/xhtml/part09'
 import XHTMLPART09_CH01 from '@/components/xhtml/part09_ch01'
 import XHTMLPART09_CH02 from '@/components/xhtml/part09_ch02'
 import XHTMLPART10 from '@/components/xhtml/part10'
 import XHTMLPART10_CH01 from '@/components/xhtml/part10_ch01'
 import XHTMLPART11 from '@/components/xhtml/part11'
 import XHTMLPART11_CH01 from '@/components/xhtml/part11_ch01'
 import XHTMLPART11_CH02 from '@/components/xhtml/part11_ch02'
 import XHTMLPART11_CH03 from '@/components/xhtml/part11_ch03'
 import XHTMLPART12 from '@/components/xhtml/part12'
 import XHTMLPART12_CH01 from '@/components/xhtml/part12_ch01'
 import XHTMLPART12_CH02 from '@/components/xhtml/part12_ch02'
 import XHTMLPART13 from '@/components/xhtml/part13'
 import XHTMLPART13_CH01 from '@/components/xhtml/part13_ch01'
 import XHTMLPART13_CH02 from '@/components/xhtml/part13_ch02'
 import XHTMLPART13_CH03 from '@/components/xhtml/part13_ch03'
 import XHTMLPART13_CH04 from '@/components/xhtml/part13_ch04'
 import XHTMLPART14 from '@/components/xhtml/part14'
 import XHTMLPART14_CH01 from '@/components/xhtml/part14_ch01'
 import XHTMLPART14_CH02 from '@/components/xhtml/part14_ch02'
 import XHTMLPART14_CH03 from '@/components/xhtml/part14_ch03'
 import XHTMLPART15 from '@/components/xhtml/part15'
 import XHTMLPART15_CH01 from '@/components/xhtml/part15_ch01'
 import XHTMLPART15_CH02 from '@/components/xhtml/part15_ch02'
 import XHTMLPART15_CH03 from '@/components/xhtml/part15_ch03'
 import XHTMLPART15_CH04 from '@/components/xhtml/part15_ch04'
 import XHTMLPART15_CH05 from '@/components/xhtml/part15_ch05'
 import XHTMLPART15_CH06 from '@/components/xhtml/part15_ch06'
 import XHTMLPART16 from '@/components/xhtml/part16'
 import XHTMLPART16_CH01 from '@/components/xhtml/part16_ch01'
 import XHTMLPART16_CH02 from '@/components/xhtml/part16_ch02'
 import XHTMLPART16_CH03 from '@/components/xhtml/part16_ch03'
 import XHTMLPART16_CH04 from '@/components/xhtml/part16_ch04'
 import XHTMLPART16_CH05 from '@/components/xhtml/part16_ch05'
 import XHTMLPART17 from '@/components/xhtml/part17'
 import XHTMLPART17_CH01 from '@/components/xhtml/part17_ch01'
 import XHTMLPART18 from '@/components/xhtml/part18'
 import XHTMLPART18_CH01 from '@/components/xhtml/part18_ch01'
 import XHTMLPART18_CH02 from '@/components/xhtml/part18_ch02'
 import XHTMLPART18_CH03 from '@/components/xhtml/part18_ch03'
 import XHTMLPART19 from '@/components/xhtml/part19'
 import XHTMLPART19_CH01 from '@/components/xhtml/part19_ch01'
 import XHTMLPART19_CH02 from '@/components/xhtml/part19_ch02'
 import XHTMLPART19_CH03 from '@/components/xhtml/part19_ch03'
 import XHTMLPART20 from '@/components/xhtml/part20'
 import XHTMLPART20_CH01 from '@/components/xhtml/part20_ch01'
 import XHTMLPART20_CH02 from '@/components/xhtml/part20_ch02'
 import XHTMLPART21 from '@/components/xhtml/part21'
 import XHTMLPART21_CH01 from '@/components/xhtml/part21_ch01'
 import XHTMLPART21_CH02 from '@/components/xhtml/part21_ch02'
 import XHTMLPART21_CH03 from '@/components/xhtml/part21_ch03'
 import XHTMLPART21_CH04 from '@/components/xhtml/part21_ch04'
 import XHTMLPART21_CH05 from '@/components/xhtml/part21_ch05'
 import XHTMLPART22 from '@/components/xhtml/part22'
 import XHTMLPART22_CH01 from '@/components/xhtml/part22_ch01'
 import XHTMLPART23 from '@/components/xhtml/part23'
 import XHTMLPART23_CH01 from '@/components/xhtml/part23_ch01'
 import XHTMLPART23_CH02_BIBLIO from '@/components/xhtml/part23_ch02_biblio'
 import XHTMLPART23_CH03_INDEX from '@/components/xhtml/part23_ch03_index'
 import XHTMLPART01_CH01_FN01 from '@/components/xhtml/part01_ch01_fn01'
 import XHTMLPART02_CH01FN01 from '@/components/xhtml/part02_ch01fn01'
 import XHTMLPART02_CH01FN02 from '@/components/xhtml/part02_ch01fn02'
 import XHTMLPART02_CH02FN01 from '@/components/xhtml/part02_ch02fn01'
 import XHTMLPART02_CH02FN02 from '@/components/xhtml/part02_ch02fn02'
 import XHTMLPART02_CH02FN03 from '@/components/xhtml/part02_ch02fn03'
 import XHTMLPART03_CH01FN01 from '@/components/xhtml/part03_ch01fn01'
 import XHTMLPART03_CH01FN02 from '@/components/xhtml/part03_ch01fn02'
 import XHTMLPART03_CH01FN03 from '@/components/xhtml/part03_ch01fn03'
 import XHTMLPART03_CH01FN04 from '@/components/xhtml/part03_ch01fn04'
 import XHTMLPART03_CH01FN05 from '@/components/xhtml/part03_ch01fn05'
 import XHTMLPART03_CH02FN01 from '@/components/xhtml/part03_ch02fn01'
 import XHTMLPART03_CH03FN01 from '@/components/xhtml/part03_ch03fn01'
 import XHTMLPART03_CH03FN02 from '@/components/xhtml/part03_ch03fn02'
 import XHTMLPART03_CH03FN03 from '@/components/xhtml/part03_ch03fn03'
 import XHTMLPART03_CH04FN01 from '@/components/xhtml/part03_ch04fn01'
 import XHTMLPART03_CH04FN02 from '@/components/xhtml/part03_ch04fn02'
 import XHTMLPART03_CH05FN01 from '@/components/xhtml/part03_ch05fn01'
 import XHTMLPART03_CH06FN02 from '@/components/xhtml/part03_ch06fn02'
 import XHTMLPART04_CH01FN01 from '@/components/xhtml/part04_ch01fn01'
 import XHTMLPART04_CH02FN01 from '@/components/xhtml/part04_ch02fn01'
 import XHTMLPART04_CH03FN01 from '@/components/xhtml/part04_ch03fn01'
 import XHTMLPART04_CH04FN01 from '@/components/xhtml/part04_ch04fn01'
 import XHTMLPART04_CH04FN02 from '@/components/xhtml/part04_ch04fn02'
 import XHTMLPART05_CH01FN01 from '@/components/xhtml/part05_ch01fn01'
 import XHTMLPART05_CH01FN02 from '@/components/xhtml/part05_ch01fn02'
 import XHTMLPART05_CH01FN03 from '@/components/xhtml/part05_ch01fn03'
 import XHTMLPART05_CH01FN04 from '@/components/xhtml/part05_ch01fn04'
 import XHTMLPART05_CH01FN05 from '@/components/xhtml/part05_ch01fn05'
 import XHTMLPART05_CH01FN06 from '@/components/xhtml/part05_ch01fn06'
 import XHTMLPART05_CH01FN07 from '@/components/xhtml/part05_ch01fn07'
 import XHTMLPART05_CH01FN08 from '@/components/xhtml/part05_ch01fn08'
 import XHTMLPART05_CH02FN01 from '@/components/xhtml/part05_ch02fn01'
 import XHTMLPART05_CH02FN02 from '@/components/xhtml/part05_ch02fn02'
 import XHTMLPART05_CH03FN01 from '@/components/xhtml/part05_ch03fn01'
 import XHTMLPART06_A_FN01 from '@/components/xhtml/part06_a_fn01'
 import XHTMLPART06_A_FN02 from '@/components/xhtml/part06_a_fn02'
 import XHTMLPART06_CH01FN03 from '@/components/xhtml/part06_ch01fn03'
 import XHTMLPART06_CH02FN01 from '@/components/xhtml/part06_ch02fn01'
 import XHTMLPART06_CH02FN02 from '@/components/xhtml/part06_ch02fn02'
 import XHTMLPART06_CH02FN03 from '@/components/xhtml/part06_ch02fn03'
 import XHTMLPART06_CH02FN04 from '@/components/xhtml/part06_ch02fn04'
 import XHTMLPART06_CH02FN05 from '@/components/xhtml/part06_ch02fn05'
 import XHTMLPART06_CH02FN06 from '@/components/xhtml/part06_ch02fn06'
 import XHTMLPART06_CH02FN07 from '@/components/xhtml/part06_ch02fn07'
 import XHTMLPART06_CH02FN08 from '@/components/xhtml/part06_ch02fn08'
 import XHTMLPART06_CH03FN01 from '@/components/xhtml/part06_ch03fn01'
 import XHTMLPART06_CH03FN02 from '@/components/xhtml/part06_ch03fn02'
 import XHTMLPART06_CH03FN03 from '@/components/xhtml/part06_ch03fn03'
 import XHTMLPART06_CH03FN04 from '@/components/xhtml/part06_ch03fn04'
 import XHTMLPART06_CH03FN05 from '@/components/xhtml/part06_ch03fn05'
 import XHTMLPART06_CH03FN06 from '@/components/xhtml/part06_ch03fn06'
 import XHTMLPART06_CH03FN07 from '@/components/xhtml/part06_ch03fn07'
 import XHTMLPART06_CH03FN08 from '@/components/xhtml/part06_ch03fn08'
 import XHTMLPART06_CH04FN01 from '@/components/xhtml/part06_ch04fn01'
 import XHTMLPART06_CH04FN02 from '@/components/xhtml/part06_ch04fn02'
 import XHTMLPART06_CH04FN03 from '@/components/xhtml/part06_ch04fn03'
 import XHTMLPART06_CH04FN04 from '@/components/xhtml/part06_ch04fn04'
 import XHTMLPART06_CH05FN01 from '@/components/xhtml/part06_ch05fn01'
 import XHTMLPART06_CH05FN02 from '@/components/xhtml/part06_ch05fn02'
 import XHTMLPART06_CH05FN03 from '@/components/xhtml/part06_ch05fn03'
 import XHTMLPART06_CH05FN04 from '@/components/xhtml/part06_ch05fn04'
 import XHTMLPART06_CH05FN05 from '@/components/xhtml/part06_ch05fn05'
 import XHTMLPART06_CH05FN06 from '@/components/xhtml/part06_ch05fn06'
 import XHTMLPART06_CH05FN07 from '@/components/xhtml/part06_ch05fn07'
 import XHTMLPART06_CH05FN08 from '@/components/xhtml/part06_ch05fn08'
 import XHTMLPART07_CH01FN01 from '@/components/xhtml/part07_ch01fn01'
 import XHTMLPART07_CH01FN02 from '@/components/xhtml/part07_ch01fn02'
 import XHTMLPART07_CH01FN03 from '@/components/xhtml/part07_ch01fn03'
 import XHTMLPART07_CH02FN02 from '@/components/xhtml/part07_ch02fn02'
 import XHTMLPART07_CH02FN03 from '@/components/xhtml/part07_ch02fn03'
 import XHTMLPART07_CH02FN04 from '@/components/xhtml/part07_ch02fn04'
 import XHTMLPART07_CH02FN05 from '@/components/xhtml/part07_ch02fn05'
 import XHTMLPART07_CH03FN01 from '@/components/xhtml/part07_ch03fn01'
 import XHTMLPART07_CH03FN02 from '@/components/xhtml/part07_ch03fn02'
 import XHTMLPART07_CH03FN03 from '@/components/xhtml/part07_ch03fn03'
 import XHTMLPART07_CH03FN04 from '@/components/xhtml/part07_ch03fn04'
 import XHTMLPART07_CH03FN05 from '@/components/xhtml/part07_ch03fn05'
 import XHTMLPART07_CH03FN06 from '@/components/xhtml/part07_ch03fn06'
 import XHTMLPART07_CH03FN07 from '@/components/xhtml/part07_ch03fn07'
 import XHTMLPART08_CH01FN01 from '@/components/xhtml/part08_ch01fn01'
 import XHTMLPART08_CH01FN02 from '@/components/xhtml/part08_ch01fn02'
 import XHTMLPART08_CH01FN03 from '@/components/xhtml/part08_ch01fn03'
 import XHTMLPART08_CH01FN04 from '@/components/xhtml/part08_ch01fn04'
 import XHTMLPART08_CH01FN05 from '@/components/xhtml/part08_ch01fn05'
 import XHTMLPART08_CH01FN06 from '@/components/xhtml/part08_ch01fn06'
 import XHTMLPART08_CH01FN07 from '@/components/xhtml/part08_ch01fn07'
 import XHTMLPART08_CH01FN08 from '@/components/xhtml/part08_ch01fn08'
 import XHTMLPART08_CH02FN01 from '@/components/xhtml/part08_ch02fn01'
 import XHTMLPART08_CH02FN02 from '@/components/xhtml/part08_ch02fn02'
 import XHTMLPART08_CH02FN03 from '@/components/xhtml/part08_ch02fn03'
 import XHTMLPART08_CH02FN04 from '@/components/xhtml/part08_ch02fn04'
 import XHTMLPART08_CH02FN05 from '@/components/xhtml/part08_ch02fn05'
 import XHTMLPART08_CH02FN06 from '@/components/xhtml/part08_ch02fn06'
 import XHTMLPART08_CH02FN07 from '@/components/xhtml/part08_ch02fn07'
 import XHTMLPART08_CH02FN08 from '@/components/xhtml/part08_ch02fn08'
 import XHTMLPART09_CH01FN01 from '@/components/xhtml/part09_ch01fn01'
 import XHTMLPART09_CH01FN02 from '@/components/xhtml/part09_ch01fn02'
 import XHTMLPART09_CH01FN03 from '@/components/xhtml/part09_ch01fn03'
 import XHTMLPART09_CH01FN04 from '@/components/xhtml/part09_ch01fn04'
 import XHTMLPART09_CH01FN05 from '@/components/xhtml/part09_ch01fn05'
 import XHTMLPART09_CH01FN06 from '@/components/xhtml/part09_ch01fn06'
 import XHTMLPART09_CH01FN07 from '@/components/xhtml/part09_ch01fn07'
 import XHTMLPART09_CH01FN08 from '@/components/xhtml/part09_ch01fn08'
 import XHTMLPART09_CH02FN02 from '@/components/xhtml/part09_ch02fn02'
 import XHTMLPART09_CH02FN03 from '@/components/xhtml/part09_ch02fn03'
 import XHTMLPART09_CH02FN04 from '@/components/xhtml/part09_ch02fn04'
 import XHTMLPART09_CH02FN05 from '@/components/xhtml/part09_ch02fn05'
 import XHTMLPART09_CH02FN06 from '@/components/xhtml/part09_ch02fn06'
 import XHTMLPART09_CH02FN07 from '@/components/xhtml/part09_ch02fn07'
 import XHTMLPART09_CH02FN08 from '@/components/xhtml/part09_ch02fn08'
 import XHTMLPART09_CH02FN09 from '@/components/xhtml/part09_ch02fn09'
 import XHTMLPART10_CH01FN01 from '@/components/xhtml/part10_ch01fn01'
 import XHTMLPART10_CH01FN02 from '@/components/xhtml/part10_ch01fn02'
 import XHTMLPART10_CH01FN03 from '@/components/xhtml/part10_ch01fn03'
 import XHTMLPART10_CH01FN04 from '@/components/xhtml/part10_ch01fn04'
 import XHTMLPART10_CH01FN05 from '@/components/xhtml/part10_ch01fn05'
 import XHTMLPART10_CH01FN06 from '@/components/xhtml/part10_ch01fn06'
 import XHTMLPART10_CH01FN07 from '@/components/xhtml/part10_ch01fn07'
 import XHTMLPART10_CH01FN08 from '@/components/xhtml/part10_ch01fn08'
 import XHTMLPART10_CH01FN09 from '@/components/xhtml/part10_ch01fn09'
 import XHTMLPART11_CH01FN01 from '@/components/xhtml/part11_ch01fn01'
 import XHTMLPART11_CH01FN02 from '@/components/xhtml/part11_ch01fn02'
 import XHTMLPART11_CH02FN02 from '@/components/xhtml/part11_ch02fn02'
 import XHTMLPART11_CH02FN03 from '@/components/xhtml/part11_ch02fn03'
 import XHTMLPART11_CH02FN04 from '@/components/xhtml/part11_ch02fn04'
 import XHTMLPART11_CH02FN05 from '@/components/xhtml/part11_ch02fn05'
 import XHTMLPART11_CH02FN06 from '@/components/xhtml/part11_ch02fn06'
 import XHTMLPART11_CH03FN01 from '@/components/xhtml/part11_ch03fn01'
 import XHTMLPART11_CH03FN02 from '@/components/xhtml/part11_ch03fn02'
 import XHTMLPART11_CH03FN03 from '@/components/xhtml/part11_ch03fn03'
 import XHTMLPART11_CH03FN04 from '@/components/xhtml/part11_ch03fn04'
 import XHTMLPART12_CH01FN01 from '@/components/xhtml/part12_ch01fn01'
 import XHTMLPART12_CH01FN02 from '@/components/xhtml/part12_ch01fn02'
 import XHTMLPART12_CH01FN03 from '@/components/xhtml/part12_ch01fn03'
 import XHTMLPART12_CH01FN04 from '@/components/xhtml/part12_ch01fn04'
 import XHTMLPART12_CH02FN01 from '@/components/xhtml/part12_ch02fn01'
 import XHTMLPART12_CH02FN02 from '@/components/xhtml/part12_ch02fn02'
 import XHTMLPART12_CH02FN03 from '@/components/xhtml/part12_ch02fn03'
 import XHTMLPART12_CH02FN04 from '@/components/xhtml/part12_ch02fn04'
 import XHTMLPART12_CH02FN05 from '@/components/xhtml/part12_ch02fn05'
 import XHTMLPART12_CH02FN06 from '@/components/xhtml/part12_ch02fn06'
 import XHTMLPART12_CH02FN07 from '@/components/xhtml/part12_ch02fn07'
 import XHTMLPART13_CH01FN01 from '@/components/xhtml/part13_ch01fn01'
 import XHTMLPART13_CH01FN02 from '@/components/xhtml/part13_ch01fn02'
 import XHTMLPART13_CH01FN03 from '@/components/xhtml/part13_ch01fn03'
 import XHTMLPART13_CH02FN01 from '@/components/xhtml/part13_ch02fn01'
 import XHTMLPART13_CH02FN02 from '@/components/xhtml/part13_ch02fn02'
 import XHTMLPART13_CH02_FN03 from '@/components/xhtml/part13_ch02_fn03'
 import XHTMLPART13_CH03_FN02 from '@/components/xhtml/part13_ch03_fn02'
 import XHTMLPART13_CH03_FN03 from '@/components/xhtml/part13_ch03_fn03'
 import XHTMLPART13_CH03_FN04 from '@/components/xhtml/part13_ch03_fn04'
 import XHTMLPART13_CH04_FN01 from '@/components/xhtml/part13_ch04_fn01'
 import XHTMLPART13_CH04_FN02 from '@/components/xhtml/part13_ch04_fn02'
 import XHTMLPART13_CH04_FN03 from '@/components/xhtml/part13_ch04_fn03'
 import XHTMLPART14_CH01_FN01 from '@/components/xhtml/part14_ch01_fn01'
 import XHTMLPART14_CH01_FN02 from '@/components/xhtml/part14_ch01_fn02'
 import XHTMLPART14_CH01_FN03 from '@/components/xhtml/part14_ch01_fn03'
 import XHTMLPART14_CH01_FN04 from '@/components/xhtml/part14_ch01_fn04'
 import XHTMLPART14_CH01_FN05 from '@/components/xhtml/part14_ch01_fn05'
 import XHTMLPART14_CH02_FN01 from '@/components/xhtml/part14_ch02_fn01'
 import XHTMLPART14_CH02_FN02 from '@/components/xhtml/part14_ch02_fn02'
 import XHTMLPART14_CH02_FN03 from '@/components/xhtml/part14_ch02_fn03'
 import XHTMLPART14_CH02_FN04 from '@/components/xhtml/part14_ch02_fn04'
 import XHTMLPART14_CH02_FN05 from '@/components/xhtml/part14_ch02_fn05'
 import XHTMLPART14_CH02_FN06 from '@/components/xhtml/part14_ch02_fn06'
 import XHTMLPART14_CH02_FN07 from '@/components/xhtml/part14_ch02_fn07'
 import XHTMLPART14_CH02_FN08 from '@/components/xhtml/part14_ch02_fn08'
 import XHTMLPART14_CH03_FN02 from '@/components/xhtml/part14_ch03_fn02'
 import XHTMLPART14_CH03_FN03 from '@/components/xhtml/part14_ch03_fn03'
 import XHTMLPART14_CH03_FN04 from '@/components/xhtml/part14_ch03_fn04'
 import XHTMLPART14_CH03_FN05 from '@/components/xhtml/part14_ch03_fn05'
 import XHTMLPART14_CH03_FN06 from '@/components/xhtml/part14_ch03_fn06'
 import XHTMLPART15_CH01_FN01 from '@/components/xhtml/part15_ch01_fn01'
 import XHTMLPART15_CH01_FN02 from '@/components/xhtml/part15_ch01_fn02'
 import XHTMLPART15_CH02_FN01 from '@/components/xhtml/part15_ch02_fn01'
 import XHTMLPART15_CH02_FN02 from '@/components/xhtml/part15_ch02_fn02'
 import XHTMLPART15_CH02_FN03 from '@/components/xhtml/part15_ch02_fn03'
 import XHTMLPART15_CH02_FN04 from '@/components/xhtml/part15_ch02_fn04'
 import XHTMLPART15_CH02_FN05 from '@/components/xhtml/part15_ch02_fn05'
 import XHTMLPART15_CH02_FN06 from '@/components/xhtml/part15_ch02_fn06'
 import XHTMLPART15_CH02_FN07 from '@/components/xhtml/part15_ch02_fn07'
 import XHTMLPART15_CH03_FN01 from '@/components/xhtml/part15_ch03_fn01'
 import XHTMLPART15_CH03_FN02 from '@/components/xhtml/part15_ch03_fn02'
 import XHTMLPART15_CH04_FN01 from '@/components/xhtml/part15_ch04_fn01'
 import XHTMLPART15_CH04_FN02 from '@/components/xhtml/part15_ch04_fn02'
 import XHTMLPART15_CH04_FN03 from '@/components/xhtml/part15_ch04_fn03'
 import XHTMLPART15_CH05_FN01 from '@/components/xhtml/part15_ch05_fn01'
 import XHTMLPART15_CH05_FN02 from '@/components/xhtml/part15_ch05_fn02'
 import XHTMLPART15_CH05_FN03 from '@/components/xhtml/part15_ch05_fn03'
 import XHTMLPART15_CH05_FN04 from '@/components/xhtml/part15_ch05_fn04'
 import XHTMLPART15_CH06_FN01 from '@/components/xhtml/part15_ch06_fn01'
 import XHTMLPART15_CH06_FN02 from '@/components/xhtml/part15_ch06_fn02'
 import XHTMLPART15_CH06_FN03 from '@/components/xhtml/part15_ch06_fn03'
 import XHTMLPART15_CH06_FN04 from '@/components/xhtml/part15_ch06_fn04'
 import XHTMLPART16_CH01_FN01 from '@/components/xhtml/part16_ch01_fn01'
 import XHTMLPART16_CH02_FN01 from '@/components/xhtml/part16_ch02_fn01'
 import XHTMLPART16_CH02_FN02 from '@/components/xhtml/part16_ch02_fn02'
 import XHTMLPART16_CH02_FN03 from '@/components/xhtml/part16_ch02_fn03'
 import XHTMLPART16_CH02_FN04 from '@/components/xhtml/part16_ch02_fn04'
 import XHTMLPART16_CH02_FN05 from '@/components/xhtml/part16_ch02_fn05'
 import XHTMLPART16_CH02_FN06 from '@/components/xhtml/part16_ch02_fn06'
 import XHTMLPART16_CH03_FN01 from '@/components/xhtml/part16_ch03_fn01'
 import XHTMLPART16_CH03_FN02 from '@/components/xhtml/part16_ch03_fn02'
 import XHTMLPART16_CH03_FN03 from '@/components/xhtml/part16_ch03_fn03'
 import XHTMLPART16_CH04_FN01 from '@/components/xhtml/part16_ch04_fn01'
 import XHTMLPART16_CH04_FN02 from '@/components/xhtml/part16_ch04_fn02'
 import XHTMLPART16_CH04_FN03 from '@/components/xhtml/part16_ch04_fn03'
 import XHTMLPART16_CH04_FN04 from '@/components/xhtml/part16_ch04_fn04'
 import XHTMLPART16_CH04_FN05 from '@/components/xhtml/part16_ch04_fn05'
 import XHTMLPART16_CH05_FN01 from '@/components/xhtml/part16_ch05_fn01'
 import XHTMLPART16_CH05_FN02 from '@/components/xhtml/part16_ch05_fn02'
 import XHTMLPART16_CH05_FN03 from '@/components/xhtml/part16_ch05_fn03'
 import XHTMLPART16_CH05_FN04 from '@/components/xhtml/part16_ch05_fn04'
 import XHTMLPART16_CH05_FN05 from '@/components/xhtml/part16_ch05_fn05'
 import XHTMLPART17_CH01_FN01 from '@/components/xhtml/part17_ch01_fn01'
 import XHTMLPART17_CH01_FN02 from '@/components/xhtml/part17_ch01_fn02'
 import XHTMLPART17_CH01_FN03 from '@/components/xhtml/part17_ch01_fn03'
 import XHTMLPART17_CH01_FN04 from '@/components/xhtml/part17_ch01_fn04'
 import XHTMLPART17_CH01_FN05 from '@/components/xhtml/part17_ch01_fn05'
 import XHTMLPART17_CH01_FN06 from '@/components/xhtml/part17_ch01_fn06'
 import XHTMLPART17_CH01_FN07 from '@/components/xhtml/part17_ch01_fn07'
 import XHTMLPART17_CH01_FN08 from '@/components/xhtml/part17_ch01_fn08'
 import XHTMLPART17_CH01_FN09 from '@/components/xhtml/part17_ch01_fn09'
 import XHTMLPART17_CH01_FN10 from '@/components/xhtml/part17_ch01_fn10'
 import XHTMLPART17_CH01_FN11 from '@/components/xhtml/part17_ch01_fn11'
 import XHTMLPART18_CH01_FN01 from '@/components/xhtml/part18_ch01_fn01'
 import XHTMLPART18_CH01_FN02 from '@/components/xhtml/part18_ch01_fn02'
 import XHTMLPART18_CH01_FN03 from '@/components/xhtml/part18_ch01_fn03'
 import XHTMLPART18_CH01_FN04 from '@/components/xhtml/part18_ch01_fn04'
 import XHTMLPART18_CH01_FN05 from '@/components/xhtml/part18_ch01_fn05'
 import XHTMLPART18_CH01_FN06 from '@/components/xhtml/part18_ch01_fn06'
 import XHTMLPART18_CH02_FN01 from '@/components/xhtml/part18_ch02_fn01'
 import XHTMLPART18_CH02_FN02 from '@/components/xhtml/part18_ch02_fn02'
 import XHTMLPART18_CH02_FN03 from '@/components/xhtml/part18_ch02_fn03'
 import XHTMLPART18_CH02_FN04 from '@/components/xhtml/part18_ch02_fn04'
 import XHTMLPART18_CH03_FN01 from '@/components/xhtml/part18_ch03_fn01'
 import XHTMLPART18_CH03_FN02 from '@/components/xhtml/part18_ch03_fn02'
 import XHTMLPART18_CH03_FN03 from '@/components/xhtml/part18_ch03_fn03'
 import XHTMLPART18_CH03_FN04 from '@/components/xhtml/part18_ch03_fn04'
 import XHTMLPART18_CH03_FN05 from '@/components/xhtml/part18_ch03_fn05'
 import XHTMLPART18_CH03_FN06 from '@/components/xhtml/part18_ch03_fn06'
 import XHTMLPART19_CH01_FN01 from '@/components/xhtml/part19_ch01_fn01'
 import XHTMLPART19_CH01_FN02 from '@/components/xhtml/part19_ch01_fn02'
 import XHTMLPART19_CH01_FN03 from '@/components/xhtml/part19_ch01_fn03'
 import XHTMLPART19_CH02_FN01 from '@/components/xhtml/part19_ch02_fn01'
 import XHTMLPART19_CH02_FN02 from '@/components/xhtml/part19_ch02_fn02'
 import XHTMLPART19_CH02_FN03 from '@/components/xhtml/part19_ch02_fn03'
 import XHTMLPART19_CH02_FN04 from '@/components/xhtml/part19_ch02_fn04'
 import XHTMLPART19_CH02_FN05 from '@/components/xhtml/part19_ch02_fn05'
 import XHTMLPART19_CH02_FN06 from '@/components/xhtml/part19_ch02_fn06'
 import XHTMLPART19_CH02_FN07 from '@/components/xhtml/part19_ch02_fn07'
 import XHTMLPART19_CH03_FN01 from '@/components/xhtml/part19_ch03_fn01'
 import XHTMLPART20_CH01_FN01 from '@/components/xhtml/part20_ch01_fn01'
 import XHTMLPART20_CH01_FN02 from '@/components/xhtml/part20_ch01_fn02'
 import XHTMLPART20_CH01_FN03 from '@/components/xhtml/part20_ch01_fn03'
 import XHTMLPART20_CH02_FN01 from '@/components/xhtml/part20_ch02_fn01'
 import XHTMLPART20_CH02_FN02 from '@/components/xhtml/part20_ch02_fn02'
 import XHTMLPART20_CH02_FN03 from '@/components/xhtml/part20_ch02_fn03'
 import XHTMLPART20_CH02_FN04 from '@/components/xhtml/part20_ch02_fn04'
 import XHTMLPART20_CH02_FN05 from '@/components/xhtml/part20_ch02_fn05'
 import XHTMLPART21_CH01_FN01 from '@/components/xhtml/part21_ch01_fn01'
 import XHTMLPART21_CH01_FN02 from '@/components/xhtml/part21_ch01_fn02'
 import XHTMLPART21_CH02_FN01 from '@/components/xhtml/part21_ch02_fn01'
 import XHTMLPART21_CH02_FN01A from '@/components/xhtml/part21_ch02_fn01a'
 import XHTMLPART21_CH02_FN02 from '@/components/xhtml/part21_ch02_fn02'
 import XHTMLPART21_CH02_FN03 from '@/components/xhtml/part21_ch02_fn03'
 import XHTMLPART21_CH02_FN04 from '@/components/xhtml/part21_ch02_fn04'
 import XHTMLPART21_CH02_FN05 from '@/components/xhtml/part21_ch02_fn05'
 import XHTMLPART21_CH02_FN06 from '@/components/xhtml/part21_ch02_fn06'
 import XHTMLPART21_CH03_FN01 from '@/components/xhtml/part21_ch03_fn01'
 import XHTMLPART21_CH03_FN02 from '@/components/xhtml/part21_ch03_fn02'
 import XHTMLPART21_CH03_FN03 from '@/components/xhtml/part21_ch03_fn03'
 import XHTMLPART21_CH03_FN04 from '@/components/xhtml/part21_ch03_fn04'
 import XHTMLPART21_CH03_FN05 from '@/components/xhtml/part21_ch03_fn05'
 import XHTMLPART21_CH03_FN06 from '@/components/xhtml/part21_ch03_fn06'
 import XHTMLPART21_CH03_FN07 from '@/components/xhtml/part21_ch03_fn07'
 import XHTMLPART21_CH03_FN08 from '@/components/xhtml/part21_ch03_fn08'
 import XHTMLPART21_CH03_FN09 from '@/components/xhtml/part21_ch03_fn09'
 import XHTMLPART21_CH03_FN10 from '@/components/xhtml/part21_ch03_fn10'
 import XHTMLPART21_CH03_FN11 from '@/components/xhtml/part21_ch03_fn11'
 import XHTMLPART21_CH04_FN01 from '@/components/xhtml/part21_ch04_fn01'
 import XHTMLPART21_CH04_FN02 from '@/components/xhtml/part21_ch04_fn02'
 import XHTMLPART21_CH04_FN03 from '@/components/xhtml/part21_ch04_fn03'
 import XHTMLPART21_CH04_FN04 from '@/components/xhtml/part21_ch04_fn04'
 import XHTMLPART21_CH04_FN05 from '@/components/xhtml/part21_ch04_fn05'
 import XHTMLPART21_CH04_FN06 from '@/components/xhtml/part21_ch04_fn06'
 import XHTMLPART21_CH04_FN07 from '@/components/xhtml/part21_ch04_fn07'
 import XHTMLPART21_CH04_FN08 from '@/components/xhtml/part21_ch04_fn08'
 import XHTMLPART21_CH05_FN01 from '@/components/xhtml/part21_ch05_fn01'
 import XHTMLPART21_CH05_FN02 from '@/components/xhtml/part21_ch05_fn02'
 import XHTMLPART22_CH01_FN01 from '@/components/xhtml/part22_ch01_fn01'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/ch00_fm09_toc",
 			"name" : "xhtml/ch00_fm09_toc",
 			"component" : XHTMLCH00_FM09_TOC
 		},
 		{
 			"path" : "/xhtml/ch00_fm10_illus",
 			"name" : "xhtml/ch00_fm10_illus",
 			"component" : XHTMLCH00_FM10_ILLUS
 		},
 		{
 			"path" : "/xhtml/part01",
 			"name" : "xhtml/part01",
 			"component" : XHTMLPART01
 		},
 		{
 			"path" : "/xhtml/part01_ch01",
 			"name" : "xhtml/part01_ch01",
 			"component" : XHTMLPART01_CH01
 		},
 		{
 			"path" : "/xhtml/part01_ch02",
 			"name" : "xhtml/part01_ch02",
 			"component" : XHTMLPART01_CH02
 		},
 		{
 			"path" : "/xhtml/part01_ch03",
 			"name" : "xhtml/part01_ch03",
 			"component" : XHTMLPART01_CH03
 		},
 		{
 			"path" : "/xhtml/part01_ch04",
 			"name" : "xhtml/part01_ch04",
 			"component" : XHTMLPART01_CH04
 		},
 		{
 			"path" : "/xhtml/part01_ch05",
 			"name" : "xhtml/part01_ch05",
 			"component" : XHTMLPART01_CH05
 		},
 		{
 			"path" : "/xhtml/part02",
 			"name" : "xhtml/part02",
 			"component" : XHTMLPART02
 		},
 		{
 			"path" : "/xhtml/part02_ch01",
 			"name" : "xhtml/part02_ch01",
 			"component" : XHTMLPART02_CH01
 		},
 		{
 			"path" : "/xhtml/part02_ch02",
 			"name" : "xhtml/part02_ch02",
 			"component" : XHTMLPART02_CH02
 		},
 		{
 			"path" : "/xhtml/part03",
 			"name" : "xhtml/part03",
 			"component" : XHTMLPART03
 		},
 		{
 			"path" : "/xhtml/part03_ch01",
 			"name" : "xhtml/part03_ch01",
 			"component" : XHTMLPART03_CH01
 		},
 		{
 			"path" : "/xhtml/part03_ch02",
 			"name" : "xhtml/part03_ch02",
 			"component" : XHTMLPART03_CH02
 		},
 		{
 			"path" : "/xhtml/part03_ch03",
 			"name" : "xhtml/part03_ch03",
 			"component" : XHTMLPART03_CH03
 		},
 		{
 			"path" : "/xhtml/part03_ch04",
 			"name" : "xhtml/part03_ch04",
 			"component" : XHTMLPART03_CH04
 		},
 		{
 			"path" : "/xhtml/part03_ch05",
 			"name" : "xhtml/part03_ch05",
 			"component" : XHTMLPART03_CH05
 		},
 		{
 			"path" : "/xhtml/part03_ch06",
 			"name" : "xhtml/part03_ch06",
 			"component" : XHTMLPART03_CH06
 		},
 		{
 			"path" : "/xhtml/part04",
 			"name" : "xhtml/part04",
 			"component" : XHTMLPART04
 		},
 		{
 			"path" : "/xhtml/part04_ch01",
 			"name" : "xhtml/part04_ch01",
 			"component" : XHTMLPART04_CH01
 		},
 		{
 			"path" : "/xhtml/part04_ch02",
 			"name" : "xhtml/part04_ch02",
 			"component" : XHTMLPART04_CH02
 		},
 		{
 			"path" : "/xhtml/part04_ch03",
 			"name" : "xhtml/part04_ch03",
 			"component" : XHTMLPART04_CH03
 		},
 		{
 			"path" : "/xhtml/part04_ch04",
 			"name" : "xhtml/part04_ch04",
 			"component" : XHTMLPART04_CH04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js